module.exports = __webpack_public_path__ + "img/github-in-space.baaee6fe.png";